import { Injectable } from '@angular/core';
import { Product } from 'src/app/auth/model/tokens';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  public static userEmail = "USER_EMAIL"
  public static userNo = "USER_ID"
  public static userName = "USER_NAME"
  public static productAccess = "PRODUCT_ACCESS"
  public static productId = "PRODUCT_ID"

  constructor() { }

  getUserEmail(): string {
    return localStorage.getItem(UserService.userEmail) || ""
  }

  setUserEmail(data: string): void {
    localStorage.setItem(UserService.userEmail, data)
  }

  removeUserEmail() {
    localStorage.removeItem(UserService.userEmail)
  }

  removeProductId() {
    localStorage.removeItem(UserService.productId)
  }

  getUserName(): string {
    return localStorage.getItem(UserService.userName) ?? ""
  }

  setUserName(data: string): void {
    localStorage.setItem(UserService.userName, data)
  }

  removeUserName() {
    localStorage.removeItem(UserService.userNo)
  }

  getUserNo(): string {
    return localStorage.getItem(UserService.userNo)
  }

  setUserNo(data: any): void {
    localStorage.setItem(UserService.userNo, data)
  }

  setProductId(data: any): void {
    localStorage.setItem(UserService.productId, data)
  }

  removeUserNo() {
    localStorage.removeItem(UserService.userNo)
  }

  getProductAccess(): Product[] {
    return JSON.parse(localStorage.getItem(UserService.productAccess)) || []
  }

  setProductAccess(data: Product[]): void {
    localStorage.setItem(UserService.productAccess, JSON.stringify(data))
  }

  removeProductAccess() {
    localStorage.removeItem(UserService.productAccess)
  }

  removeAllUserData() {
    this.removeUserEmail()
    this.removeUserName()
    this.removeUserName()
    this.removeProductAccess()
  }

}
